import { LeftAxis } from "./LeftAxis";
export default LeftAxis;
